import { z } from 'zod'
const jsonObject = z.record(z.unknown())
export const billingContractReadBindingResponseSchema = jsonObject
export type BillingContractReadBindingResponse = z.infer<typeof billingContractReadBindingResponseSchema>
